import React from 'react';
import { useDispatch } from 'react-redux';
import { usePage } from 'ha/modules/Page/contexts/PageContext';
import { track } from 'ha/modules/Analytics/actions';
import { Props as TrackProps, Track } from './Track';

type ContexValues = { [K: string]: any };

const Context = React.createContext<ContexValues>({});

export const TrackContext: React.FC<ContexValues> = ({
  children,
  ...props
}) => <Context.Provider value={props}>{children}</Context.Provider>;

type Props = Omit<TrackProps, 'page' | 'onTrack'>;

const SmartTrackInternal: React.FC<Props> = ({ children, name, ...props }) => {
  const dispatch = useDispatch();
  const contextValues = React.useContext(Context);
  const { name: pageName } = usePage();

  const onTrack = React.useCallback((...args) => {
    dispatch(track(...args));
  }, []);

  return (
    <Track
      page={pageName}
      onTrack={onTrack}
      name={name}
      {...contextValues}
      {...props}
    >
      {children}
    </Track>
  );
};

const SmartTrack = React.memo(SmartTrackInternal);
export { SmartTrack };
